import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-addc4d96")

_pushScopeId("data-v-addc4d96")
const _hoisted_1 = {
  key: 0,
  class: "app h-100"
}
const _hoisted_2 = { class: "notificationBox" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_4 = { class: "notificationTitle" }
const _hoisted_5 = { class: "notificationText" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_global_spinner = _resolveComponent("global-spinner")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_modals_container = _resolveComponent("modals-container")!

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.$store.state.globalSpinner > 0)
          ? (_openBlock(), _createBlock(_component_global_spinner, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withId(() => [
            (_ctx.$store.state.notification)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "notificationDrawer",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.$store.state.notificationFunction && _ctx.$store.state.notificationFunction(...args)))
                }, [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("button", {
                      type: "button",
                      class: "notificationClose",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$store.state.notification = null), ["stop","prevent"]))
                    }, [
                      _hoisted_3
                    ]),
                    _createVNode("div", _hoisted_4, [
                      _createVNode("span", {
                        innerHTML: _ctx.$store.state.notification.title
                      }, null, 8, ["innerHTML"])
                    ]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode("span", {
                        innerHTML: _ctx.$store.state.notification.body
                      }, null, 8, ["innerHTML"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_router_view),
        _createVNode(_component_modals_container)
      ]))
    : _createCommentVNode("", true)
})